module.exports = __webpack_public_path__ + "17432f47fe51e303876aa6fcaeb0e1d8.gltf";